var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blank"}},[_vm._v(" Hello, Welcome Here ")])}
var staticRenderFns = []

export { render, staticRenderFns }